import { moduleProviderFactory } from 'core/providers';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.administration',
				pattern: '',
				authorization: ['coreApplicationSettingSection.read'],
				component: '',
				isPrivate: true,
			},
			{
				name: 'master.app.main.receiving',
				pattern: '',
				authorization: ['coreApplicationSettingSection.read'],
				component: '',
				isPrivate: true,
			},
			{
				name: 'master.app.main.order',
				pattern: '',
				authorization: ['coreApplicationSettingSection.read'],
				component: '',
				isPrivate: true,
			},
			{
				name: 'master.app.main.shipment-status',
				pattern: '',
				authorization: ['shipmentStatusSection.read', 'shipmentStatusReturnSection.read'],
				component: '',
				isPrivate: true,
			},
		],
		menu: [
			{
				title: 'MAINMENU.ADMINISTRATION.TITLE',
				route: 'master.app.main.administration',
				iconOpen: 'fa fa-caret-up nav--secondary__caret',
				iconClose: 'fa fa-caret-down nav--secondary__caret',
				iconName: 'fa fa-shield-alt spc--right--sml',
				order: 0,
				children: [
					{
						title: 'MAINMENU.ADMINISTRATION.ROLES',
						route: 'master.app.main.role.list',
						authorization: ['roleMenuSection.full'],
						iconName: 'fa fa-user-shield spc--right--sml',
						order: 0,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.USERS',
						route: 'master.app.main.user.list',
						iconName: 'fa fa-users spc--right--sml',
						order: 1,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.CHANNELS',
						route: 'master.app.main.channel.list',
						iconName: 'fa fa-project-diagram spc--right--sml',
						order: 2,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.SHIPPINGCARRIERS',
						route: 'master.app.main.carrier.list',
						authorization: ['shippingCarrierSection.full'],
						iconName: 'fa fa-shipping-fast spc--right--sml',
						order: 3,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.LOOKUPS',
						route: 'master.app.main.lookup.list',
						authorization: ['fulfillmentLookupSection.full'],
						iconName: 'fa fa-cubes spc--right--sml',
						order: 4,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.WAREHOUSES',
						route: 'master.app.main.warehouse.list',
						iconName: 'fa fa-warehouse spc--right--sml',
						authorization: ['platformSection.full'],
						order: 5,
					},
					{
						title: 'MAINMENU.ADMINISTRATION.PRODUCTS',
						route: 'master.app.main.product.list',
						iconName: 'fa fa-box spc--right--sml',
						order: 6,
						subroutes: [
							'master.app.main.product.list.edit',
							'master.app.main.product.list.detail',
							'master.app.main.product.list.add',
						],
					},
					{
						title: 'MAINMENU.ADMINISTRATION.SELLERS',
						route: 'master.app.main.seller.list',
						iconName: 'fa fa-building spc--right--sml',
						authorization: ['platformSection.full'],
						order: 7,
						subroutes: [
							'master.app.main.seller.list.edit',
							'master.app.main.seller.list.detail',
							'master.app.main.seller.list.add',
						],
					},
					{
						title: 'MAINMENU.ADMINISTRATION.RETURNADDRESS',
						route: 'master.app.main.return-address.list',
						iconName: 'fa fa-undo spc--right--sml',
						authorization: ['shippingCarrierSection.full'],
						order: 8,
					},
				],
			},
			{
				title: 'MAINMENU.INVENTORY.TITLE',
				route: 'master.app.main.inventory.list',
				iconName: 'fa fa-warehouse spc--right--sml',
				order: 1,
			},
			{
				title: 'MAINMENU.FULFILLMENTORDERS.TITLE',
				route: 'master.app.main.order.list',
				iconName: 'fa fa-folder-open spc--right--sml',
				order: 2,
				subroutes: ['master.app.main.order.list.detail', 'master.app.main.product.list.detail'],
			},
			{
				title: 'MAINMENU.SHIPMENTSTATUS.TITLE',
				route: 'master.app.main.shipment-status',
				iconOpen: 'fa fa-caret-up nav--secondary__caret',
				iconClose: 'fa fa-caret-down nav--secondary__caret',
				iconName: 'fa fa-box-open spc--right--sml',
				authorization: ['shipmentStatusSection.read', 'shipmentStatusReturnSection.read'],
				order: 3,
				children: [
					{
						title: 'SHIPMENTSTATUSVIEW.FULFILLMENTSHIPMENTS',
						route: 'master.app.main.shipment-info.list',
						authorization: ['shipmentStatusSection.read'],
						iconName: 'fa fa-solid fa-share spc--right--sml',
						order: 0,
					},
					{
						title: 'SHIPMENTSTATUSVIEW.RETURNSHIPMENTS',
						route: 'master.app.main.shipment-info-return.list',
						authorization: ['shipmentStatusReturnSection.read'],
						iconName: 'fa fa-solid fa-reply spc--right--sml',
						order: 1,
					},
				],
			},
			{
				title: 'MAINMENU.CONTAINERS.TITLE',
				route: 'master.app.main.receiving',
				iconOpen: 'fa fa-caret-up nav--secondary__caret',
				iconClose: 'fa fa-caret-down nav--secondary__caret',
				authorization: ['receivingSection.read'],
				iconName: 'fa fa fa-dolly-flatbed spc--right--sml spc--right--sml',
				order: 4,
				children: [
					{
						title: 'MAINMENU.CONTAINERS.MANUAL',
						route: 'master.app.main.receiving.manual.list',
						authorization: ['receivingSection.read'],
						iconName: 'fa fa fa-dolly-flatbed spc--right--sml spc--right--sml',
						order: 0,
					},
					{
						title: 'MAINMENU.CONTAINERS.AUTOMATED',
						route: 'master.app.main.receiving.automated.list',
						authorization: ['receivingSection.read'],
						iconName: 'fa fa-truck-moving spc--right--sml',
						order: 1,
					},
				],
			},
			{
				title: 'MAINMENU.PICKINGBATCHES.TITLE',
				route: 'master.app.main.picking-batch.list',
				iconName: 'fa fa-truck-pickup spc--right--sml',
				authorization: ['pickingBatchSection.full'],
				order: 5,
			},
			{
				title: 'MAINMENU.MARKETPLACEORDERS',
				route: 'master.app.main.order.marketplace.list',
				iconName: 'fa fa-boxes spc--right--sml',
				order: 6,
				subroutes: [
					'master.app.main.order.marketplace.list.detail',
					'master.app.main.order.marketplace.list.add',
					'master.app.main.order.list.edit',
				],
				showUnlinkedOrderLines: true,
			},
			{
				title: 'MAINMENU.SHIPMENTCOST.TITLE',
				route: 'master.app.main.shipment-cost',
				iconName: 'fa fa-dollar-sign spc--right--sml',
				authorization: ['shipmentCostSection.full'],
				order: 7,
			},
			{
				title: 'MAINMENU.RATECALCULATOR.TITLE',
				route: 'master.app.main.rate-calculator',
				iconName: 'fa fa-calculator spc--right--sml',
				authorization: ['rateCalculatorSection.full'],
				order: 8,
			},
			{
				title: 'MAINMENU.REPORTS.TITLE',
				route: 'master.app.main.report.list',
				iconName: 'fa fa-regular fa-file spc--right--sml',
				authorization: ['reportSection.full'],
				subroutes: ['master.app.main.report.list.add'],
				order: 9,
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/menu/config.js